import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import UserHeader from "../../components/UserHeader";
import Footer from "../../components/Footer";
import userStore from "../../zustand/userStore";
import { BASE_URL } from "../../configs/WebServiceUrl";
import { InitiatePaymentThunk } from "../../features/pricing/redux/thunks";
import "./pricing.css";

const INR = (amount) => `₹${Number(amount || 0).toLocaleString("en-IN")}`;

export default function CoachingPricing({ embedded = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCoachingPlans = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/api/subscriptionmodel/coaching`);
        const data = Array.isArray(response.data) ? response.data : [];
        setPlans(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching coaching subscription models:", err);
        setError("Failed to load coaching plans.");
      } finally {
        setLoading(false);
      }
    };

    fetchCoachingPlans();
  }, []);

  const handleCoachingPayment = (plan) => {
    if (!userData) {
      alert("Please login to continue.");
      return;
    }

    const body = {
      txnRefNo: Date.now(),
      amount: plan?.price || 0,
      txnType: "Pay",
      orderInfo: String(plan?.model_id || ""),
      email: userData?.email || "",
      firstName: userData?.admin_name || userData?.name || "",
      lastName: "",
      street: "Delhi",
      city: "",
      state: "",
      zip: 506002,
      phone: userData?.contact_number || 0,
      udf21: userData?.admin_id || userData?.id,
      udf22: userData?.id,
      udf23: "",
      udf24: plan?.model_type || "coaching",
      udf25: plan?.total_users || 1,
      udf26: "",
      udf27: String(plan?.model_id || ""),
    };

    console.log("Coaching Plan Payment Body:", body);
    dispatch(InitiatePaymentThunk(body));
  };

  return (
    <div className="dw-app">
      {!embedded && <UserHeader />}

      {!embedded && (
        <section className="pl-hero">
          <h1 className="pl-hero-title">Coaching &amp; Tuition Centre Plans</h1>
          <p className="pl-hero-sub">
            Choose a plan based on the size of your teaching centre.
          </p>
        </section>
      )}

      <main className={`pl-page${embedded ? "" : " has-hero"}`}>
        {loading ? (
          <div className="text-center my-5 fs-5">Loading Coaching Plans...</div>
        ) : error ? (
          <div className="text-center my-5 text-danger fs-5">{error}</div>
        ) : plans.length === 0 ? (
          <div className="text-center my-5 fs-5">No coaching plans available.</div>
        ) : (
          <div className="pl-grid">
            {plans.map((tier, index) => {
              const planTitle = `Plan ${index + 1}`;
              let addData = {};
              if (tier.additional_data) {
                try {
                  addData =
                    typeof tier.additional_data === "string"
                      ? JSON.parse(tier.additional_data)
                      : tier.additional_data;
                } catch (e) {
                  addData = {};
                }
              }
              const perUserPrice =
                addData.price_per_teacher || addData.price_per_user || null;

              return (
                <section key={tier.model_id || tier.id || index} className="pl-card">
                  <p className="pl-card-name">{planTitle}</p>

                  {tier.description && (
                    <p className="pl-capacity" style={{ whiteSpace: "pre-line" }}>
                      {tier.description}
                    </p>
                  )}

                  {tier.total_users && (
                    <p className="pl-storage">Users: {tier.total_users}</p>
                  )}

                  <div className="pl-price">{INR(tier.price)}</div>

                  {perUserPrice && (
                    <p className="pl-per-user">{INR(perUserPrice)} per user</p>
                  )}

                  <div className="pl-actions">
                    <button
                      type="button"
                      className="dw-btn dw-btn-primary pl-btn-block"
                      onClick={() => handleCoachingPayment({ ...tier, planTitle, perUserPrice })}
                    >
                      Subscribe
                    </button>
                  </div>
                </section>
              );
            })}
          </div>
        )}
      </main>

      {!embedded && <Footer userData={userData} />}
    </div>
  );
}
